import { FileText, BookOpen, Wrench, PuzzlePiece, House, Cloud, Browser, MagnifyingGlass, Megaphone, Cpu, EnvelopeSimple, Phone, UsersThree, NotePencil, MapPin, CursorClick } from "@phosphor-icons/react";

export const TYPE_META = {
  agreement: { label: "Agreements", singular: "Agreement", icon: FileText, blurb: "Contracts, DPAs and partnership terms." },
  doc: { label: "Docs", singular: "Doc", icon: BookOpen, blurb: "Guides, methodology and strategy." },
  manual: { label: "Manuals", singular: "Manual", icon: Wrench, blurb: "Installation and setup instructions." },
  plugin: { label: "Plugins", singular: "Plugin", icon: PuzzlePiece, blurb: "Downloadable WordPress plugins." },
};

export const TYPES = ["agreement", "doc", "manual", "plugin"];

export const SECTION_META = {
  "web-hosting": { label: "Web Hosting", icon: Cloud, blurb: "Managed hosting, migrations and uptime." },
  "wordpress": { label: "WordPress", icon: Browser, blurb: "Development, integrations and WooCommerce." },
  "seo": { label: "SEO", icon: MagnifyingGlass, blurb: "Search & AI-answer visibility." },
  "google-ads": { label: "Google Ads", icon: Megaphone, blurb: "Paid search, shopping and PPC." },
  "ai-services": { label: "AI Services", icon: Cpu, blurb: "AI-readiness, 3LA and implementation." },
};

export const SECTIONS = ["web-hosting", "wordpress", "seo", "google-ads", "ai-services"];

export const ROLE_META = {
  lead: { label: "Lead", color: "text-muted-foreground border-border" },
  client: { label: "Client", color: "text-foreground border-muted-foreground/40" },
  customer: { label: "Customer", color: "text-primary border-primary/30" },
  partner: { label: "Partner", color: "text-primary border-primary/60" },
  admin: { label: "Admin", color: "text-primary border-primary" },
  super_admin: { label: "Super Admin", color: "text-primary-foreground bg-primary border-primary" },
};

export const STATUS_META = {
  new: { label: "New", color: "text-muted-foreground border-border" },
  prospect: { label: "Prospect", color: "text-primary/80 border-primary/30" },
  active: { label: "Active", color: "text-primary border-primary/60" },
  churned: { label: "Churned", color: "text-muted-foreground border-border opacity-60" },
};

export const HOME_ICON = House;

export const ACTIVITY_META = {
  email: { label: "Email", icon: EnvelopeSimple },
  call: { label: "Call", icon: Phone },
  meeting: { label: "Meeting", icon: UsersThree },
  note: { label: "Note", icon: NotePencil },
  visit: { label: "Visit", icon: MapPin },
  web_action: { label: "Website action", icon: CursorClick },
};

export const ACTIVITY_TYPES = ["email", "call", "meeting", "note", "visit", "web_action"];
